import { EnvMicroMasterData } from "lib-klab-core";

export const envMasterDataLocal: EnvMicroMasterData = {
  host: "",
  apiBasePath: "/ms-master-data",
  useMocks: false,
};

export const envMasterDataDev: EnvMicroMasterData = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-master-data",
  useMocks: false,
};

export const envMasterDataProd: EnvMicroMasterData = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-master-data",
  useMocks: false,
};
